interface Step {
  id: number;
  label: string;
  icon: string;
}

const STEPS: Step[] = [
  { id: 1, label: 'Доставка', icon: 'ri-truck-line' },
  { id: 2, label: 'Оплата', icon: 'ri-bank-card-line' },
  { id: 3, label: 'Подтверждение', icon: 'ri-check-double-line' },
];

interface Props {
  current: number;
}

const CheckoutSteps = ({ current }: Props) => (
  <div className="flex items-center justify-center gap-0 mb-10">
    {STEPS.map((step, idx) => {
      const done = current > step.id;
      const active = current === step.id;
      return (
        <div key={step.id} className="flex items-center">
          <div className="flex flex-col items-center gap-1.5">
            <div
              className="w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300"
              style={{
                background: done ? '#39ff14' : active ? '#ff2d78' : 'rgba(255,255,255,0.06)',
                border: done ? '2px solid #39ff14' : active ? '2px solid #ff2d78' : '2px solid rgba(255,255,255,0.1)',
                boxShadow: done ? '0 0 12px rgba(57,255,20,0.5)' : active ? '0 0 16px rgba(255,45,120,0.6)' : 'none',
              }}
            >
              {done
                ? <i className="ri-check-line text-sm font-bold" style={{ color: '#050508' }} />
                : <i className={`${step.icon} text-sm`} style={{ color: active ? '#fff' : 'rgba(255,255,255,0.3)' }} />
              }
            </div>
            <span
              className="font-mono text-xs whitespace-nowrap"
              style={{ color: done ? '#39ff14' : active ? '#ff2d78' : 'rgba(255,255,255,0.3)' }}
            >
              {step.label}
            </span>
          </div>
          {idx < STEPS.length - 1 && (
            <div
              className="w-16 md:w-24 h-px mx-2 mb-5 transition-all duration-500"
              style={{ background: done ? '#39ff14' : 'rgba(255,255,255,0.08)' }}
            />
          )}
        </div>
      );
    })}
  </div>
);

export default CheckoutSteps;
